// extracted by mini-css-extract-plugin
export default {"menu":"BurgerMenu_menu__tPFhj","button":"BurgerMenu_button__vAait","close-button":"BurgerMenu_close-button__3pH8A"};